export default __webpack_public_path__ + "static/media/sconto-king.b941fc88.svg";